import * as React from 'react';

import Icon from '../../components/Icon/Icon';

const SvgCrossComponent = (props: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1024 1024' {...props}>
        <path d='M10.462 10.462c13.95-13.95 36.567-13.95 50.517 0L512 461.481 963.023 10.462c13.95-13.95 36.564-13.95 50.514 0s13.95 36.567 0 50.517L562.519 512l451.018 451.023c13.95 13.95 13.95 36.564 0 50.514s-36.564 13.95-50.514 0L512 562.519 60.979 1013.537c-13.95 13.95-36.567 13.95-50.517 0s-13.95-36.564 0-50.514L461.483 512 10.462 60.979c-13.95-13.95-13.95-36.567 0-50.517z' />
    </svg>
);

const SvgCross = (props: any) => (
    <Icon {...props}>
        <SvgCrossComponent />
    </Icon>
);

export default SvgCross;
